/* eslint-disable */
import proto from './protobuf';
import { utils } from './utils';

const observers = [];
const res_callbacks = [];
let messageId = 0;

function getMsgId() {
  if (messageId > Number.MAX_SAFE_INTEGER) {
    messageId = 0;
  } else {
    messageId += 1;
  }
  return messageId;
}

function sendMessage(moduleName, type, category, msg, callback, timeout = 30, extend = undefined) {
  const request = new proto.PCMMessage();
  request.setMessageid(getMsgId());
  request.setMsgmodule(moduleName);
  request.setMsgcategory(category);
  request.setMsgtype(type === undefined ? proto.PCMessageType.PCM_MESSAGE_TYPE_REQUEST : type);
  let content;
  if (msg === null || msg === undefined) {
    content = msg;
  } else if (typeof msg === 'string') {
    content = utils.toUTF8Array(msg);
  } else if (msg) {
    try {
      content = msg.serializeBinary();
    } catch (e) {
      content = null;
    }
  }
  request.setMessageproto(content);
  request.setExtend(extend);
  request.setIdentiy(window.pcmIdentity ? window.pcmIdentity : 0); // 请求的唯一标识
  const messageRequest = {
    request,
    callback,
    timeout: timeout * 1000 + new Date().getTime(),
  };
  const messageBase64 = utils.arrayBufferToBase64(messageRequest.request.serializeBinary());
  utils.sendNativeMessage('ProtoMessage', messageBase64);

  // 只有PCM_MESSAGE_TYPE_REQUEST的消息才需要回调
  if (callback !== undefined && type === proto.PCMessageType.PCM_MESSAGE_TYPE_REQUEST) {
    res_callbacks.push(messageRequest);
  }
}

function requestPlugin(plugin, category, messageBody, callback) {
  return sendMessage(
    proto.PCMMessageModule.PCM_MESSAGE_MODULE_WSPLUGIN,
    proto.PCMessageType.PCM_MESSAGE_TYPE_REQUEST,
    category,
    messageBody,
    (successed, msg) => {
      if (callback) {
        callback(successed, utils.arrayToUTF8String(msg.getMessageproto()));
      }
    },
    null,
    plugin,
  );
}

function requestNative(category, messageBody, callback) {
  return requestPlugin('WSAppStorePlugin', category, messageBody, callback);
}

function requestCommon(category, messageBody, callback) {
  requestPlugin('WSCommonPlugin', category, messageBody, callback);
}

function subscribeMessage(cb) {
  observers.push(cb);
}

function publishMessage(data) {
  const protoMsg = proto.PCMMessage.deserializeBinary(data);
  if (protoMsg.getMsgtype() === proto.PCMessageType.PCM_MESSAGE_TYPE_RESPONSE) {
    // 有回调
    for (let index = 0; index < res_callbacks.length; index++) {
      const cbm = res_callbacks[index];
      if (cbm.request.getMessageid() === protoMsg.getMessageid()) {
        res_callbacks.splice(index, 1);
        return cbm.callback(true, protoMsg);
      }
    }
  } else if (protoMsg.getMsgtype() === proto.PCMessageType.PCM_MESSAGE_TYPE_NOTIFY) {
    // 主动通知
    observers.forEach(ob => {
      if (typeof ob === 'function') {
        ob(protoMsg);
      }
    });
  }
}

export const bridge = {
  requestNative,
  requestCommon,
  subscribeMessage,
  publishMessage,
  sendMessage,
};
